import { useQuery } from "react-query";
import { superviseesQueryKeys } from "queries/constants";
import { QueryOptions } from "queries/queries";
import { useToast } from "components/common/ui/toast/useToast";
import { fetchOneSuperviseePlan } from "api/SupervisorsApi";

export const useSuperviseePlanDetail = (
  supervisorId: string,
  superviseeId: string,
  planId: string,
  options?: QueryOptions
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    superviseesQueryKeys.plans(planId),
    () => fetchOneSuperviseePlan(supervisorId, superviseeId, planId),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load supervisee plan detail", {
          id: superviseesQueryKeys.plans(planId).join("::"),
        }),
      staleTime: 60 * 1000,
      ...options,
    }
  );
};
